//#region src/gql/scalar-resolvers.ts
var CustomScalarResolvers = {
	ApiCancelSubscriptionPayload: {
		cancelAt: (p) => typeof p.cancelAt === "string" ? new Date(p.cancelAt) : null,
		currentPeriodEnd: (p) => typeof p.currentPeriodEnd === "string" ? new Date(p.currentPeriodEnd) : null
	},
	ApiConnectPayment: {
		createdAt: (p) => typeof p.createdAt === "string" ? new Date(p.createdAt) : null,
		updatedAt: (p) => typeof p.updatedAt === "string" ? new Date(p.updatedAt) : null
	},
	ApiCreateSubscriptionPayload: { currentPeriodEnd: (p) => typeof p.currentPeriodEnd === "string" ? new Date(p.currentPeriodEnd) : null },
	ApiOrganizationSubscription: { currentPeriodEnd: (p) => typeof p.currentPeriodEnd === "string" ? new Date(p.currentPeriodEnd) : null },
	ApiPlatformMemberCustomerSuccess: {
		createdAt: (p) => typeof p.createdAt === "string" ? new Date(p.createdAt) : null,
		updatedAt: (p) => typeof p.updatedAt === "string" ? new Date(p.updatedAt) : null
	},
	ApiStripeConnectSubscription: {
		cancelAt: (p) => typeof p.cancelAt === "string" ? new Date(p.cancelAt) : null,
		canceledAt: (p) => typeof p.canceledAt === "string" ? new Date(p.canceledAt) : null,
		createdAt: (p) => typeof p.createdAt === "string" ? new Date(p.createdAt) : null,
		currentPeriodEnd: (p) => typeof p.currentPeriodEnd === "string" ? new Date(p.currentPeriodEnd) : null,
		currentPeriodStart: (p) => typeof p.currentPeriodStart === "string" ? new Date(p.currentPeriodStart) : null,
		updatedAt: (p) => typeof p.updatedAt === "string" ? new Date(p.updatedAt) : null
	},
	ApiStripeConnectedAccount: { created: (p) => typeof p.created === "string" ? new Date(p.created) : null },
	PingDate: { dt: (p) => typeof p.dt === "string" ? new Date(p.dt) : null }
};
//#endregion
export { CustomScalarResolvers };

//# sourceMappingURL=scalar-resolvers.js.map